( function( $, window ) {
	'use strict';

	var $pageSidebar;
	var $pageMenu;
	var $pageMenuTrigger;
	var $pageMenuBody;
	var $pageMenuLink;
	var activeClassName = 'is-active';
	var resizeTimer;

	function registerClickHandler() {
		$pageMenuTrigger.on( 'click.qrc.pagemenu', function( event ) {
			event.preventDefault();
			$( this ).toggleClass( activeClassName );
			$pageMenuBody.slideToggle();
		} );
	}

	function positionMenu() {
		if ( $( window ).scrollTop() > $pageSidebar.offset().top && window.matchMedia( '(max-width: 1023px)' ).matches ) {
			$pageMenu.addClass( 'is-fixed' );
		} else {
			$pageMenu.removeClass( 'is-fixed' );
		}
	}

	function registerScrollHandler() {
		$( window ).on( 'scroll.qrc.pagemenu', function() {
			positionMenu();
		} );
	}

	function registerResizeHandler() {
		$( window ).on( 'resize.qrc.pagemenu', function() {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( function() {
				positionMenu();
			}, 250 );
		} );
	}

	function registerMenuItemClickHandler() {
		$pageMenuLink.on( 'click.qrc.pagemenu.link', function() {
			$pageMenuTrigger.removeClass( activeClassName );
			$pageMenuBody.slideUp();
		} );
	}

	$( function() {
		$pageSidebar = $( '.js-page-sidebar' );
		$pageMenu = $( '.js-page-menu' ).first();
		$pageMenuTrigger = $( '.js-page-menu-trigger' ).first();
		$pageMenuBody = $( '.js-page-menu-body' );
		$pageMenuLink = $( '.js-page-menu-link' );

		enquire.register( '(max-width: 1023px)', {
			match: function() {
				if ( $pageMenu.length ) {
					registerClickHandler();
					registerScrollHandler();
					registerResizeHandler();
					registerMenuItemClickHandler();
					positionMenu();
				}
			}
		} );

		enquire.register( '(min-width: 1024px)', {
			match: function() {
				if ( $pageMenu.length ) {
					console.log( 'matched' );
					$( window ).off( 'scroll.qrc.pagemenu' );
					$( window ).off( 'resize.qrc.pagemenu' );
					$pageMenuTrigger.off( 'click.qrc.pagemenu' );
					$pageMenuLink.off( 'click.qrc.pagemenu.link' );
					$pageMenu.removeClass( 'is-fixed' );
				}
			}
		} );
	} );
} )( jQuery, window );
